// extracted by mini-css-extract-plugin
export var hideEditor = "_ni-2";
export var infoIcon = "_ni-3";
export var label = "_ni-1";
export var labelContainer = "_ni-0";
export var readonlyText = "_ni-4";